<template>
  <!-- :type=" -->
  <!-- order.success ? 'success' : order.showStatusMessage ? 'error' : 'info' -->
  <!-- " -->
  <v-alert :type="order.color" text>
    <template v-if="order.showStatusMessage">
      <v-avatar color="white" size="32">
        <v-img
          v-if="client && client.image_path"
          :src="conf.apiUrlBase + '/gallery/' + client.image_path"
        ></v-img>
        <span v-else class="black--text text-h6">
          {{ translate(getInitials(client)) }}
        </span>
      </v-avatar>
      {{ translate(order.lastStatusMessage) }}
      <span v-if="overlay">
        {{ $t("next_wait") }}
        <span v-if="!settings.mode === 'manual'">{{ countdownSeconds }}</span>
      </span>
    </template>
    <template v-else>
      <span v-if="overlay">
        <span v-if="client">
          <v-avatar color="white" size="32">
            <v-img
              v-if="client.image_path"
              :src="conf.apiUrlBase + '/gallery/' + client.image_path"
            ></v-img>
            <span v-else class="black--text text-h6">
              {{ translate(getInitials(client)) }}
            </span>
          </v-avatar>
        </span>
        {{ $t("next_wait") }}
        <span v-if="!settings.mode === 'manual'">
          {{ countdownSeconds }}
        </span>
      </span>
      <span v-else>{{ $t("next_scan") }}</span>
    </template>
  </v-alert>
</template>

<script>
import conf from "@/config";
export default {
  name: "PaymentAlert",
  props: {
    client: {
      type: Object,
      default: null,
    },
    order: {
      type: Object,
      default: () => ({}),
    },
    countdownSeconds: {
      type: Number,
      default: 0,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      conf,
    };
  },
  methods: {
    getInitials(client) {
      if (!client || !client.name) return "";
      return client.name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
    },
    getInitials(user) {
      const firstInitial = user?.name?.trim()?.charAt(0).toUpperCase() || "";
      const lastInitial = user?.lastname?.trim()?.charAt(0).toUpperCase() || "";
      return this.toLatin(firstInitial + lastInitial);
    },
  },
};
</script>
